/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Ideal_Dragonfly_SproutInputs */

const fr_vivid_ideal_dragonfly_sprout = /** @type {(inputs: Vivid_Ideal_Dragonfly_SproutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la section`)
};

/**

* @param {Vivid_Ideal_Dragonfly_SproutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const vivid_ideal_dragonfly_sprout = /** @type {((inputs?: Vivid_Ideal_Dragonfly_SproutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Ideal_Dragonfly_SproutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_vivid_ideal_dragonfly_sprout(inputs)
});